/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 8V12M18 8H14M18 8L14.4196 12.2964C14.4035 12.3158 14.3954 12.3256 14.3886 12.3335C13.6371 13.2165 12.2946 13.2774 11.4662 12.4661C11.4588 12.4588 11.4498 12.4498 11.432 12.432V12.432C11.4155 12.4155 11.4072 12.4072 11.4002 12.4003C10.6225 11.6378 9.37753 11.6378 8.59979 12.4003C8.59275 12.4072 8.58452 12.4155 8.56804 12.432L6 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18 8V12M18 8H14M18 8L14.4196 12.2964C13.6573 13.2112 12.274 13.274 11.432 12.432V12.432C10.6411 11.6411 9.35889 11.6411 8.56804 12.432L6 15M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM14 7.25C13.5858 7.25 13.25 7.58579 13.25 8C13.25 8.41421 13.5858 8.75 14 8.75H16.3987L13.8435 11.8163L13.8175 11.8474C13.3478 12.3992 12.5087 12.4373 11.991 11.9302L11.9623 11.9016L11.9599 11.8993C11.9459 11.8852 11.9351 11.8744 11.9253 11.8648C10.8559 10.8163 9.1441 10.8163 8.07471 11.8648L8.04033 11.899L8.03771 11.9016L5.46967 14.4697C5.17678 14.7626 5.17678 15.2374 5.46967 15.5303C5.76256 15.8232 6.23744 15.8232 6.53033 15.5303L9.09837 12.9623L9.12487 12.9359C9.61096 12.4593 10.389 12.4593 10.8751 12.9359L10.9016 12.9623L10.9045 12.9652C10.9196 12.9802 10.9311 12.9918 10.9414 13.0019C12.0805 14.1174 13.9264 14.0337 14.9597 12.8196C14.9691 12.8086 14.9796 12.796 14.9933 12.7796L14.9958 12.7766L17.25 10.0715V12C17.25 12.4142 17.5858 12.75 18 12.75C18.4142 12.75 18.75 12.4142 18.75 12V8C18.75 7.58579 18.4142 7.25 18 7.25H14Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 22H9V22C7.13872 22 6.20808 22 5.45492 21.7553C3.93273 21.2607 2.73931 20.0673 2.24472 18.5451C2 17.7919 2 16.8613 2 15V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V15C22 16.8613 22 17.7919 21.7553 18.5451C21.2607 20.0673 20.0673 21.2607 18.5451 21.7553C17.7919 22 16.8613 22 15 22V22H14.5M18 8V12M18 8H14M18 8L14.4196 12.2964C13.6573 13.2112 12.274 13.274 11.432 12.432V12.432C10.6411 11.6411 9.35889 11.6411 8.56804 12.432L6 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 8V12M18 8H14M18 8L14.4196 12.2964C13.6573 13.2112 12.274 13.274 11.432 12.432V12.432C10.6411 11.6411 9.35889 11.6411 8.56804 12.432L6 15M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.25 8C13.25 7.58579 13.5858 7.25 14 7.25H18C18.4142 7.25 18.75 7.58579 18.75 8V12C18.75 12.4142 18.4142 12.75 18 12.75C17.5858 12.75 17.25 12.4142 17.25 12V10.0715L14.9958 12.7766L14.9933 12.7796C14.9796 12.796 14.9691 12.8086 14.9597 12.8196C13.9264 14.0337 12.0805 14.1174 10.9414 13.0019C10.9311 12.9918 10.9196 12.9802 10.9045 12.9652L10.9016 12.9623L10.8751 12.9359C10.389 12.4593 9.61096 12.4593 9.12487 12.9359L9.09837 12.9623L6.53033 15.5303C6.23744 15.8232 5.76256 15.8232 5.46967 15.5303C5.17678 15.2374 5.17678 14.7626 5.46967 14.4697L8.03771 11.9016L8.04033 11.899C8.05425 11.8851 8.06498 11.8744 8.07471 11.8648C9.1441 10.8163 10.8559 10.8163 11.9253 11.8648C11.9356 11.875 11.9471 11.8864 11.9623 11.9016L11.991 11.9302C12.5087 12.4373 13.3478 12.3992 13.8175 11.8474L13.8435 11.8163L16.3987 8.75H14C13.5858 8.75 13.25 8.41421 13.25 8Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
